import type { ParentProps } from 'solid-js';
import { MainLayout } from './MainLayout';
import { ProtectedRoute } from '@/features/auth/components/ProtectedRoute';

export default function ProtectedLayout(props: ParentProps) {
  return (
    <ProtectedRoute>
      <MainLayout>{props.children}</MainLayout>
    </ProtectedRoute>
  );
}
